module.exports = __webpack_public_path__ + "static/promote-edb7fdc23351737e3188adbeffdb18ea.png";